import React from 'react'

import { WrapperContainer, Content, TextContent } from './styles'
import { BsFillExclamationCircleFill } from 'react-icons/bs'

const NotQuestion: React.FC = () => {
  return (
    <WrapperContainer>
      <Content>
        <BsFillExclamationCircleFill size={60} color="#5E6871" />
      </Content>
      <TextContent>
        <h4>Nenhum resultado encontrado. Ajuste o filtro e tente novamente.</h4>
      </TextContent>
    </WrapperContainer>
  )
}

export default NotQuestion
